import {$http} from '@/utils/https'
import {
    CHANGE_HOMEWORK_FILTER_COURSE,
    CHANGE_HOMEWORK_FILTER_STATUS,
    CHANGE_SKIP,
    CLEAR_HOMEWORK_FILTERS,
    GET_LIST_LOADING,
    GET_STATUS_LIST_LOADING,
    SET_LIST,
    SET_LIST_LENGTH,
    SET_STATUS_LIST
} from './types/mutation-types';


import {GET_LIST, GET_STATUS_LIST} from './types/action-types';

const state = {
    list: [],
    isListLoading: false,
    listLength: 0,
    skip: 0,
    limit: 15,
    filterCourse: '',
    filterStatus: '',

    statusList: [],
    isStatusListLoading: false,
};

const getters = {
    list: state => state.list,
    isListLoading: state => state.isListLoading,
    listLength: state => state.listLength,
    limit: state => state.limit,
    dateFrom: state => state.dateFrom,
    dateTo: state => state.dateTo,

    statusList: state => state.statusList,
    isStatusListLoading: state => state.isStatusListLoading,

    filterCourse: state => state.filterCourse,
    filterStatus: state => state.filterStatus,
};

const actions = {
    [GET_LIST]: async ({dispatch, commit}, payload) => {
        try {
            commit(GET_LIST_LOADING, true);
            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}my/courses/works?include=course,summary,userWorks.homeWork.module,userWorks.graduateWork&skip=${state.skip}&limit=${state.limit}&filters[finished_from]=${payload.dateFrom}&filters[finished_to]=${payload.dateTo}&filters[course_id]=${state.filterCourse}&filters[status_id]=${state.filterStatus}`, payload);
            commit(SET_LIST, response.data.data);
            commit(SET_LIST_LENGTH, response.data.meta.total);
        } catch (e) {
            throw e;
        } finally {
            commit(GET_LIST_LOADING, false);
        }
    },
    [GET_STATUS_LIST]: async ({dispatch, commit}, payload) => {
        try {
            commit(GET_STATUS_LIST_LOADING, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}setting`, payload);
            commit(SET_STATUS_LIST, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(GET_STATUS_LIST_LOADING, false);
        }
    }
};

const mutations = {
    [SET_LIST](state, data) {
        if (data.length) {
            // state.list.push(...data);
            state.list = data;
        } else {
            state.list = data;
        }
    },
    [GET_LIST_LOADING](state, status) {
        state.isListLoading = status;
    },
    [SET_LIST_LENGTH](state, length) {
        state.listLength = length;
    },


    [SET_STATUS_LIST](state, data) {
        if (data.length) {
            state.statusList.push(...data);
        } else {
            state.statusList = data;
        }
    },
    [GET_STATUS_LIST_LOADING](state, status) {
        state.isStatusListLoading = status;
    },

    [CHANGE_SKIP](state, status = true) {
        if (status) {
            state.skip += state.limit;
        } else {
            state.skip = 0
        }
    },

    [CHANGE_HOMEWORK_FILTER_COURSE](state, status) {
        state.filterCourse = status;
    },

    [CHANGE_HOMEWORK_FILTER_STATUS](state, status) {
        state.filterStatus = status;
    },
    [CLEAR_HOMEWORK_FILTERS](state) {
        state.filterStatus = '';
        state.filterCourse = '';
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
